import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=ae669ec0&scoped=true"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=ae669ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae669ec0",
  null
  
)

export default component.exports